var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { SVGIcon, SVGIconGroup, SVGIconPath } from '../../components/SVGIcon';
var PinMarkerIconShape = React.createElement(SVGIconGroup, null, React.createElement(SVGIconPath, {
  d: "M11.9166133,2 C7.54648255,2.00505138 4.00505138,5.54648255 4,9.91661326 C4,15.3724098 9.44829658,20.3232097 11.117452,21.7107004 C11.5804842,22.0953532 12.251909,22.0953532 12.7149412,21.7107004 C14.3815966,20.3232097 19.8332265,15.3707431 19.8332265,9.91577993 C19.8277161,5.54597466 16.2864191,2.00505045 11.9166133,2 Z M11.9166133,14.0832518 C9.61544233,14.0832518 7.7499747,12.2177842 7.7499747,9.91661326 C7.7499747,7.61544233 9.61544233,5.7499747 11.9166133,5.7499747 C14.2177842,5.7499747 16.0832518,7.61544233 16.0832518,9.91661326 C16.0832518,11.0216745 15.6442679,12.0814753 14.8628716,12.8628716 C14.0814753,13.6442679 13.0216745,14.0832518 11.9166133,14.0832518 L11.9166133,14.0832518 Z"
}));
export var PinMarkerIcon = function PinMarkerIcon(props) {
  var className = props.className,
      restProps = __rest(props, ["className"]);

  return React.createElement(SVGIcon, Object.assign({}, restProps, {
    className: "PinMarkerIcon ".concat(className || '')
  }), PinMarkerIconShape);
};